import { render } from "./InputErrorIcon.vue?vue&type=template&id=54bd5f08"
import script from "./InputErrorIcon.vue?vue&type=script&lang=js"
export * from "./InputErrorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__